var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3658_3768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9991 0C5.37182 0 0 5.37257 0 11.9991C0 18.6263 5.37182 23.9981 11.9991 23.9981C18.6256 23.9981 23.9981 18.6263 23.9981 11.9991C23.9981 5.37257 18.6256 0 11.9991 0ZM11.9991 22.4982C6.20054 22.4982 1.49991 17.7976 1.49991 11.9991C1.49991 6.20054 6.20054 1.49991 11.9991 1.49991C17.7976 1.49991 22.4982 6.20054 22.4982 11.9991C22.4982 17.7976 17.7976 22.4982 11.9991 22.4982Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5356 4.71925C12.3946 4.57974 12.1974 4.49951 11.9994 4.49951C11.8021 4.49951 11.6049 4.58049 11.4639 4.71925L6.21506 9.89309C5.91883 10.1863 5.91957 10.661 6.21506 10.9535C6.51128 11.2468 6.99047 11.2468 7.2867 10.9535L11.2426 7.0538V18.7484C11.2426 19.1624 11.5816 19.4983 12.0001 19.4983C12.4186 19.4983 12.7576 19.1623 12.7576 18.7484V7.05455L16.7135 10.9543C17.009 11.2468 17.4889 11.2468 17.7844 10.9543C18.0799 10.661 18.0799 10.1863 17.7844 9.89384L12.5356 4.71925Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3658_3768"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.ca2d7f50d712bcf3e6a33de59a3d2c90.svg";
export { ForwardRef as ReactComponent };